import { useCallback, useEffect, useRef } from 'react';

const MAX_QUEUE_LENGTH = 100;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useQueueUntilReady = <CB extends (...args: any[]) => void>(
  callback: CB,
  ready: boolean,
): CB => {
  const queue = useRef<(() => void)[]>([]);

  const readyRef = useRef(ready);
  readyRef.current = ready;

  useEffect(() => {
    if (!ready || queue.current.length === 0) return;

    let delayedCall: (() => void) | undefined;
    // eslint-disable-next-line no-cond-assign
    while ((delayedCall = queue.current.shift())) {
      delayedCall();
    }
  }, [ready]);

  return useCallback(
    (...args: Parameters<CB>) => {
      if (readyRef.current) {
        return callback(...args);
      }
      queue.current.push(() => callback(...args));
      if (queue.current.length > MAX_QUEUE_LENGTH) {
        queue.current.shift();
      }
    },
    [callback],
  ) as CB;
};

export default useQueueUntilReady;
